import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  position: relative;
  width: 100%;
  .MuiAccordion-root {
    gap: 0 !important;
  }
  .MuiPaper-root {
    gap: 0;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
`;
export const DetailWrapper = styled(AccordionDetails)`
  padding: ${(p) => p.theme.spacing(2)};
  border-width: 0 1px 1px 1px;
  border-style: solid;
`;

export const CustomAccordion = styled(Accordion)`
  background: ${(p) => p.theme.palette.common.white};
  .MuiAccordion-root {
    gap: 0 !important;
  }

  &.Mui-expanded {
    box-shadow: none;
  }
  .MuiPaper-root {
    gap: 0;
  }
`;
export const CustomSummary = styled(AccordionSummary)`
  border: 1px solid;
  padding: ${(p) => p.theme.spacing(0, 2)};
  color: ${(p) => p.theme.palette.primary[500]};
  font-size: ${(p) => p.theme.typography.body2};
`;
